import { useController } from 'react-hook-form';
import { PinInput } from 'rsuite';
import { FormGroup } from '@shared/ui/forms/display';

export default function CodePinInput({ control, name, error, label }) {
  const { field } = useController({
    control,
    name,
    rules: { required: true },
  });

  return (
    <FormGroup error={error} label={label}>
      <PinInput {...field} placeholder="_" length={6} size="lg" />
    </FormGroup>
  );
}
